import clsx from 'clsx';
import Image from 'next/image';
import { resolveImageAltText } from '@/lib/utils';
import { SvgPlus } from './SvgPlus';

export function MainProductCard({ data }) {
  const { blockData, toggleIsUpsell, selectedCard, handleClick } = data;
  const { details, image, title } = blockData;
  return (
    <div
      id="bundle-upsell-toggle-main-card"
      className={clsx('flex h-full flex-col border-2 px-2 py-2', {
        'border-light-green bg-parlor-green-115': selectedCard === 'main',
        'border-parlor-green-80': selectedCard !== 'main'
      })}
      tabIndex={0}
      role="button"
      aria-pressed={selectedCard === 'main'}
      aria-label={`${title}`}
      onClick={() => handleClick('main')}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick('main');
        }
      }}
    >
      <div>
        <div className="relative flex justify-between">
          <div className="sh12 text-white">{title}</div>
          <>
            <input
              type="radio"
              id={`select-${title}`}
              name="upsell-toggle-product"
              value={title}
              className="absolute top-[6px] right-[4px] h-0 w-0"
              defaultChecked={selectedCard === 'main'}
            />
            <label htmlFor={`select-${title}`}>
              <span className="sr-only">{title}</span>
            </label>
            {selectedCard === 'main' ? (
              <div className="border-light-green bg-parlor-green-115 relative z-20 flex h-4 w-4 rounded-full border">
                <div className="bg-light-green z-30 mx-auto my-auto h-2 w-2 rounded-full"></div>
              </div>
            ) : (
              <div className="bg-parlor-green-80 z-20 h-4 w-4 rounded-full border border-white"></div>
            )}
          </>
        </div>
        <div className="price-r-label text-dawn-grey-60 pb-[2px]">
          This item
        </div>
      </div>
      <div>
        {image?.url && image?.dimension && (
          <Image
            src={`${image.url}?format=webp&disable=upscale`}
            width={image.dimension.width}
            height={image.dimension.height}
            alt={resolveImageAltText(image)}
            className="pb-[2px]"
          />
        )}
        {details.map((detail, index) => (
          <div key={index} className={clsx({ flex: !toggleIsUpsell })}>
            {!toggleIsUpsell && <SvgPlus />}
            <div className="body-s text-white">{detail.detail}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
